import { CardContent, TextField } from '@material-ui/core';
import FancyCard from '../../../components/fancy/FancyCard';
import React from 'react';

function PaymentFormCash({ note, setNote }) {
    return (
        <FancyCard fullWidth>
            <CardContent>
                <h3 className="mb-2">Pay with cash</h3>
                <h5>The payment doesn&apos;t require credit card, you pay with cash.</h5>
                <TextField
                    fullWidth
                    label="Private agent notes (to identify the customer)"
                    name="cashnote"
                    placeholder="Fill out with the required information, like room number, booking identifier, etc."
                    type="text"
                    value={note}
                    onChange={ev => {
                        setNote(ev.target.value);
                    }}
                />
            </CardContent>
        </FancyCard>
    );
}

export default PaymentFormCash;
